import React from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '../../../../_shared';

import styles from './ToolbarButton.module.scss';

const propTypes = {

	/**
	 * Unique id for the toolbar button element.
	 */
	id: PropTypes.string.isRequired,

	/**
	 * Flag specifying if button is disabled.
	 */
	disabled: PropTypes.bool,

	/**
	 * Flag specifying if button is active.
	 */
	active: PropTypes.bool,

	/**
	 * Icon to display.
	 */
	icon: PropTypes.string.isRequired,

	/**
	 * The button title.
	 */
	title: PropTypes.string.isRequired,

	/**
	 * Flag indicating if button behavior should be configured for inline placement.
	 */
	inline: PropTypes.bool,

	/**
	 * Function handler when button is clicked.
	 */
	onClick: PropTypes.func,

};

const ToolbarButton = (props) => {

	const {
		id,
		disabled,
		active,
		icon,
		title,
		inline,
		onClick,
		...restProps
	} = props;

	const activeStyleName = active ? styles.active : '';
	const disabledStyleName = disabled ? styles.disabled : '';
	const inlineStyleName = inline ? styles.inline : '';

	return (
		<IconButton
			{...restProps}
			id={id}
			className={`${restProps.className || ''} ${styles['toolbar-btn']} ${activeStyleName} ${disabledStyleName} ${inlineStyleName}`.trim()}
			title={title}
			icon={icon}
			disabled={disabled}
			aria-pressed={active}
			placement="top"
			tooltip
			onClick={onClick} />
	);

};

ToolbarButton.propTypes = propTypes;

export default ToolbarButton;
